import { PODCAST_LISTEN_PLATFORMS, PODCAST_SHOWS, type PodcastShow } from '../../data/podcastShows';

type Props = {
  selectedShowId: string | null;
  onSelectShow: (show: PodcastShow) => void;
};

export default function PodcastLibrarySection({ selectedShowId, onSelectShow }: Props) {
  return (
    <section className="podcast-library" aria-labelledby="podcast-library-heading">
      <header className="podcast-library__header text-center">
        <h2 id="podcast-library-heading" className="podcast-library__title sbr-section__title fw-bold mb-0">
          A library of insights for <span className="text-gradient-teal-blue">hiring</span> leaders.
        </h2>
        <p className="podcast-library__subtitle sbr-section__lead mx-auto mt-3 mb-0">
          Curated conversations. Timeless lessons.
        </p>
      </header>

      <div className="podcast-library__showcase">
        <div className="podcast-library__grid">
          {PODCAST_SHOWS.map((show) => {
            const isSelected = selectedShowId === show.id;
            return (
              <article
                key={show.id}
                className={['podcast-library-card', isSelected && 'podcast-library-card--selected']
                  .filter(Boolean)
                  .join(' ')}
              >
                <button
                  type="button"
                  className="podcast-library-card__link"
                  onClick={() => onSelectShow(show)}
                  aria-label={`Browse episodes for ${show.title}`}
                  aria-pressed={isSelected}
                >
                  <div className="podcast-library-card__visual">
                    <div className="podcast-library-card__media">
                      <img
                        src={show.image}
                        alt={show.title}
                        width={3000}
                        height={3000}
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                    <div className="podcast-library-card__reflection" aria-hidden="true">
                      <div className="podcast-library-card__reflection-inner">
                        <img src={show.image} alt="" width={3000} height={3000} decoding="async" />
                      </div>
                    </div>
                  </div>
                  <p className="podcast-library-card__category">
                    {show.accent ? (
                      <span
                        className={[
                          'podcast-library-card__category-accent',
                          show.accent === 'blue' && 'podcast-library-card__category-accent--blue',
                        ]
                          .filter(Boolean)
                          .join(' ')}
                      />
                    ) : null}
                    <span className="podcast-library-card__category-text">{show.category}</span>
                  </p>
                </button>
              </article>
            );
          })}
        </div>

        <div className="podcast-library__listen">
          <p className="podcast-library__listen-label">Listen on</p>
          <div className="podcast-library__platforms">
            {PODCAST_LISTEN_PLATFORMS.map((platform) =>
              platform.enabled ? (
                <a
                  key={platform.id}
                  className="podcast-library__platform"
                  href={platform.href}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={platform.icon}
                    alt=""
                    className="podcast-library__platform-icon"
                    decoding="async"
                  />
                  <span className="podcast-library__platform-label">{platform.label}</span>
                </a>
              ) : (
                <span
                  key={platform.id}
                  className="podcast-library__platform podcast-library__platform--disabled"
                  aria-disabled="true"
                  title={`${platform.label} — coming soon`}
                >
                  <img
                    src={platform.icon}
                    alt=""
                    className="podcast-library__platform-icon"
                    decoding="async"
                  />
                  <span className="podcast-library__platform-label">{platform.label}</span>
                </span>
              ),
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
